import React from "react";
import { makeStyles } from "@material-ui/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import MainTheme from "../../Theme";
import AppWrapTheme from "../../ThemeAppWrap";
import logo from "../../images/logo-avaliare-white.png";
import { Route, Switch } from "react-router-dom";

import {
  GruposAlimentaresList,
  GruposAlimentaresForm,
  ReceitasTabs,
  ReceitasList,
  TiposRefeicoesList,
  TiposRefeicoesForm,
  CardapioTabs,
  CardapiosList,
} from "../Nutricao";

import { ClientesList, ClienteTabs } from "../Clientes";

import {
  ServicosList,
  ServicosForm,
  InbodyList,
  InbodyForm,
  SecaList,
  SecaForm,
  BodymetrixRegiaoList,
  BodymetrixRegiaoForm,
  BodymetrixAvaliacaoList,
  BodymetrixAvaliacaoTabs,
  IndicadorAvalList,
  IndicadorAvalForm,
  AvalAvaliacaoList,
  AvalAvaliacaoTabs,
  TesteRecuperacaoList,
  TesteRecuperacaoForm,
  EvalAptInstanceList,
  EvalAptInstanceForm,
} from "../Servicos";

import {
  TreinoObjetivoList,
  TreinoObjetivoForm,
  ExerciciosList,
  ExerciciosForm,
  TreinoList,
  TreinoForm,
} from "../Treino";

import { DicasList, DicasForm } from "../Dicas";

import { NotificacaoList, NotificacaoForm } from "../Notificacao";
import AntropometriaForm from "./../Servicos/AntropometriaForm";
import { AntropometriaList } from "./../Servicos/Antropometria";
import { AppWrap } from "elentari";
import HalterIcon from "../../components/icons/HalterIcon";
import AvalIcon from "../../components/icons/AvalIcon";
import NutritionIcon from "../../components/icons/NutritionIcon";
import PerfilIcon from "../../components/icons/PerfilIcon";
import NotificationIcon from "../../components/icons/NotificationIcon";

const menuItems = [
  {
    icon: PerfilIcon,
    pathname: `/clientes`,
    label: "Clientes",
  },
  {
    group: true,
    label: "Avaliação",
    icon: AvalIcon,
    items: [
      {
        pathname: "/inbody",
        label: "Inbody",
      },
      {
        pathname: "/seca",
        label: "Seca",
      },
      {
        pathname: "/teste-recuperacao",
        label: "Teste de recuperação",
      },
      {
        pathname: "/bodymetrix-avaliacao",
        label: "Bodymetrix Avaliação",
      },
      {
        pathname: "/bodymetrix-regiao",
        label: "Bodymetrix Região",
      },
      {
        pathname: "/aval-avaliacao",
        label: "Avaliação Aptidão Física",
      },
      {
        pathname: "/indicador-aval",
        label: "Indicadores Aptidão Física",
      },
      // {
      //   pathname: "/eval-apt-instance",
      //   label: "Avaliação de Aptidão",
      // },
      {
        pathname: "/antropometria",
        label: "Antropometria",
      },
    ],
  },
  {
    group: true,
    label: "Nutrição",
    icon: NutritionIcon,
    items: [
      {
        pathname: `/grupos-alimentares`,
        label: "Grupos Alimentares",
      },
      {
        pathname: `/receitas`,
        label: "Receitas",
      },
      {
        pathname: `/tipos-de-refeicoes`,
        label: "Tipos de Refeições",
      },
      {
        pathname: `/cardapios`,
        label: "Cardápios",
      },
    ],
  },
  {
    group: true,
    label: "Treinos",
    icon: HalterIcon,
    items: [
      {
        pathname: `/treinos`,
        label: "Treinos",
      },
      {
        pathname: `/treino-objetivos`,
        label: "Treino Objetivos",
      },
      {
        pathname: `/exercicios`,
        label: "Exercicios",
      },
    ],
  },
  {
    icon: PerfilIcon,
    label: "Dicas",
    pathname: "/dicas",
  },
  {
    icon: PerfilIcon,
    label: "Serviços",
    pathname: "/servicos",
  },
  {
    icon: NotificationIcon,
    pathname: "/notificacoes",
    label: "Notificações",
  },
];

const createListNavigationActions = (history, name) => ({
  onClickNew: () => history.push(`/${name}/new`),
  onClickEdit: (item) => history.push(`/${name}/${item.id}`),
});

const appWrapMakeStyles = makeStyles({
  drawerPaper: {
    backgroundColor: "white !important",
  },
  navBarRoot: {
    backgroundColor: "white !important",
  },
});

const Home = () => {
  const appWrapClasses = appWrapMakeStyles();
  return (
    <MuiThemeProvider theme={AppWrapTheme}>
      <AppWrap
        logo={
          <img
            src={logo}
            alt="Logo da Avaliare"
            style={{ width: 140, paddingLeft: 5 }}
          />
        }
        menuItems={menuItems}
        classes={appWrapClasses}
      >
        <MuiThemeProvider theme={MainTheme}>
          <Switch>
            <Route
              path="/grupos-alimentares"
              exact
              component={GruposAlimentaresList}
            />
            <Route
              path="/grupos-alimentares/:id"
              exact
              component={GruposAlimentaresForm}
            />
            <Route path="/clientes" exact component={ClientesList} />
            <Route path="/clientes/:id" component={ClienteTabs} />
            <Route path="/receitas" exact component={ReceitasList} />
            <Route path="/receitas/:id" component={ReceitasTabs} />
            <Route
              path="/tipos-de-refeicoes"
              exact
              component={TiposRefeicoesList}
            />
            <Route
              path="/tipos-de-refeicoes/:id"
              exact
              component={TiposRefeicoesForm}
            />
            <Route
              path="/cardapios"
              exact
              render={(props) => (
                <CardapiosList
                  withPaper
                  {...props}
                  {...createListNavigationActions(props.history, "cardapios")}
                />
              )}
            />
            <Route path="/cardapios/:id" component={CardapioTabs} />
            <Route
              path="/treino-objetivos"
              exact
              component={TreinoObjetivoList}
            />
            <Route
              path="/treino-objetivos/:id"
              exact
              component={TreinoObjetivoForm}
            />
            <Route path="/servicos" exact component={ServicosList} />
            <Route path="/servicos/:id" exact component={ServicosForm} />
            <Route path="/exercicios" exact component={ExerciciosList} />
            <Route path="/exercicios/:id" exact component={ExerciciosForm} />
            <Route path="/dicas" exact component={DicasList} />
            <Route path="/dicas/:id" exact component={DicasForm} />
            <Route path="/treinos" exact component={TreinoList} />
            <Route path="/treinos/:id" component={TreinoForm} />
            <Route
              path="/inbody"
              exact
              render={(props) => (
                <InbodyList
                  {...props}
                  withPaper
                  {...createListNavigationActions(props.history, "inbody")}
                />
              )}
            />
            <Route
              path="/inbody/:id"
              exact
              render={(props) => <InbodyForm {...props} withPaper showClient />}
            />
            <Route
              path="/antropometria"
              exact
              render={(props) => (
                <AntropometriaList
                  {...props}
                  withPaper
                  {...createListNavigationActions(
                    props.history,
                    "antropometria"
                  )}
                />
              )}
            />
            <Route
              path="/antropometria/:id"
              exact
              render={(props) => (
                <AntropometriaForm {...props} withPaper showClient />
              )}
            />
            <Route
              path="/seca"
              exact
              render={(props) => (
                <SecaList
                  {...props}
                  withPaper
                  {...createListNavigationActions(props.history, "seca")}
                />
              )}
            />
            <Route
              path="/seca/:id"
              exact
              render={(props) => <SecaForm {...props} withPaper showClient />}
            />
            <Route path="/notificacoes" exact component={NotificacaoList} />
            <Route path="/notificacoes/:id" component={NotificacaoForm} />
            <Route
              path="/teste-recuperacao"
              exact
              component={TesteRecuperacaoList}
            />
            <Route
              path="/teste-recuperacao/:id"
              component={TesteRecuperacaoForm}
            />
            <Route
              path="/bodymetrix-regiao"
              exact
              component={BodymetrixRegiaoList}
            />
            <Route
              path="/bodymetrix-regiao/:id"
              component={BodymetrixRegiaoForm}
            />
            <Route
              path="/bodymetrix-avaliacao"
              exact
              render={(props) => (
                <BodymetrixAvaliacaoList
                  withPaper
                  {...props}
                  {...createListNavigationActions(
                    props.history,
                    "bodymetrix-avaliacao"
                  )}
                />
              )}
            />
            <Route
              path="/bodymetrix-avaliacao/:id"
              component={BodymetrixAvaliacaoTabs}
            />
            <Route path="/indicador-aval" exact component={IndicadorAvalList} />
            <Route path="/indicador-aval/:id" component={IndicadorAvalForm} />
            <Route
              path="/aval-avaliacao"
              exact
              render={(props) => (
                <AvalAvaliacaoList
                  withPaper
                  {...props}
                  {...createListNavigationActions(
                    props.history,
                    "aval-avaliacao"
                  )}
                />
              )}
            />
            <Route path="/aval-avaliacao/:id" component={AvalAvaliacaoTabs} />

            <Route
              path="/eval-apt-instance"
              exact
              component={EvalAptInstanceList}
            />
            <Route
              path="/eval-apt-instance/:id"
              component={EvalAptInstanceForm}
            />
          </Switch>
        </MuiThemeProvider>
      </AppWrap>
    </MuiThemeProvider>
  );
};

export default Home;
